import type { AxiosInstance } from 'axios'
import { ApiService } from '@/services/ApiService'
import { authProvider } from '@/services/currentAuthProvider'

let apiService: ApiService | null = null

/** The singleton ApiService, which adds the signed-in user's ID token to every request. */
export function initApiService(): ApiService {
  if (!apiService) {
    apiService = new ApiService(authProvider)
  }
  return apiService
}

/** The authenticated axios instance, for responses like blob PDF downloads. */
export function getAxiosInstance(): AxiosInstance {
  return initApiService().getAxios()
}
